import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent, DialogTitle, Dialog } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { TransitionGroup } from 'react-transition-group';
import FadeTransition from 'components/transitions/Fade';

const styles = {
  header: {
      fontFamily: 'NewOrderBold',
      fontWeight: '700',
      fontSize: '16px',
      lineHeight: '22px',
      textAlign: 'center',
      color: '#0076BB',
  },
  content: {
    fontFamily: 'NiveauGroteskRegular',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '2%',
  },
};

const Info = ({ open, onClose }) => {
  return (
    <TransitionGroup>
      <FadeTransition>
        <Dialog
          onRequestClose={onClose}
          open={open}
        >
          <DialogTitle>
            <div
              role='presentation'
              style={{ position: 'absolute', height: '100%', width: '30px', background: '#E9F5FC', right: '-4px', top: '0', cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
              onClick={onClose}
            >
              <ArrowLeftIcon style={{ top: '45%', position: 'relative' }} />
            </div>
          </DialogTitle>
          <DialogContent style={{ overflowX: 'hidden' }}>
            <div style={styles.header}>About Frito Lay</div>
            <div style={styles.content}>Frito Lay makes the snacks you love and has fun doing it! With 29 brands, the Frito Lay team of dedicated employees goes the extra mile to bring you your favorite refreshments for game day. From chips and popcorn to cookies and nuts, there’s a snack to please every palette!</div>
            <div style={styles.header}>About FOX Sports</div>
            <div style={styles.content}>FOX Sports is the umbrella entity representing FOX Corporation’s wide array of multi-platform US-based sports assets. Built with brands capable of reaching more than 100 million viewers in a single weekend, FOX Sports includes the sports television arm of the FOX Network – FS1, FS2, FOX Soccer Plus and FOX Deportes. Bringing you access to watch the women’s USA soccer team, get ready to tune in for game day!</div>
          </DialogContent>
          {/* </Card> */}
        </Dialog>
      </FadeTransition>
    </TransitionGroup>
  );
};
Info.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Info;
